module.exports = __webpack_public_path__ + "static/media/villa-terracota-casa-360-preview.00196ca8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/360photos/villa-terracota-casa-360-preview.jpg
// module id = 1153
// module chunks = 0